/**
 * Created by anatoly on 06.02.2025
 */

const SwapHintAlgorithm = {
    type: "swap",

    findMove: function () {
        if (!Game.currentGame || !Game.currentGame.field) {
            return;
        }

        const field = Game.currentGame.field;

        const pseudo = PseudoRandom.GET("secondary");
        pseudo.randomSeed();

        const move = pseudo.choose(field.findValidMove(true));

        if (!move) {
            return;
        }

        move.type = SwapHintAlgorithm.type;
        move.delay = 3000;

        const cellToSwap = field.cells[move.start.y + move.dir.row][move.start.x + move.dir.col];
        field.swap(move.start, cellToSwap, true);
        move.shape = field.findAllShapes(move.start)[0];
        field.swap(move.start, cellToSwap, true);

        return move;
    }
};

AvailableMove.REGISTERED_ALGORITHMS.push(SwapHintAlgorithm);